export default __webpack_public_path__ + "static/media/LabTransferred.8624a32f.svg";